/**
 * 版本管理
 * **/

const verApi = {
  //获取列表
  getList: '/AppInfo/GetList',
  //获取信息
  getInfo: '/AppInfo/GetInfo',
  //添加
  add: '/AppInfo/Add',
  //修改
  edit: '/AppInfo/Edit',
  //删除
  delete: '/AppInfo/Del',
}

export default verApi
